/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum ApplicationEntry {
  '首页Banner-推荐列表-推荐结果申请加入' = 400,
  '首页Banner-推荐列表-推荐结果进入公会详情-详情页申请加入' = 4042,
  '首页Banner-推荐列表-搜索结果申请加入' = 411,
  '首页Banner-推荐列表-搜索结果进入公会详情-详情页申请加入' = 4142,
  '房内Banner-推荐列表-推荐结果申请加入' = 500,
  '房内Banner-推荐列表-推荐结果进入公会详情-详情页申请加入' = 5042,
  '房内Banner-推荐列表-搜索结果申请加入' = 511,
  '房内Banner-推荐列表-搜索结果进入公会详情-详情页申请加入' = 5142,
  '金刚区-推荐列表-推荐结果申请加入' = 600,
  '金刚区-推荐列表-推荐结果进入公会详情-详情页申请加入' = 6042,
  '金刚区-推荐列表-搜索结果申请加入' = 611,
  '金刚区-推荐列表-搜索结果进入公会详情-详情页申请加入' = 6142,
  '房间固定位-推荐列表-推荐结果申请加入' = 700,
  '房间固定位-推荐列表-推荐结果进入公会详情-详情页申请加入' = 7042,
  '房间固定位-推荐列表-搜索结果申请加入' = 711,
  '房间固定位-推荐列表-搜索结果进入公会详情-详情页申请加入' = 7142,
  '房间固定位-半屏浮窗-推荐列表-推荐结果申请加入' = 7200,
  '房间固定位-半屏浮窗-推荐列表-推荐结果进入公会详情-详情页申请加入' = 72042,
  '房间固定位-半屏浮窗-推荐列表-搜索结果申请加入' = 7211,
  '房间固定位-半屏浮窗-推荐列表-搜索结果进入公会详情-详情页申请加入' = 72142,
  '系统推荐-半屏浮窗-推荐列表-推荐结果申请加入' = 9200,
  '系统推荐-半屏浮窗-推荐列表-推荐结果进入公会详情-详情页申请加入' = 92042,
  '系统推荐-半屏浮窗-推荐列表-搜索结果申请加入' = 9211,
  '系统推荐-半屏浮窗-推荐列表-搜索结果进入公会详情-详情页申请加入' = 92142,
  '系统推荐-关闭房间弹窗-推荐列表-推荐结果申请加入' = 9300,
  '系统推荐-关闭房间弹窗-推荐列表-推荐结果进入公会详情-详情页申请加入' = 93042,
  '系统推荐-关闭房间弹窗-推荐列表-搜索结果申请加入' = 9311,
  '系统推荐-关闭房间弹窗-推荐列表-搜索结果进入公会详情-详情页申请加入' = 93142,

  '房间固定位-半屏浮窗-公会详情-详情页申请加入' = 7242,
  '房间固定位-公会详情-详情页申请加入' = 742,
  '系统推荐-半屏浮窗-公会详情-详情页申请加入' = 9242,
  '主播分享-详情页申请加入' = 82,
  '其他' = 0,
}

export enum HomePageBuryingPointEnum {
  主页banner = 0,
  房间内banner = 1,
  金刚区 = 2,
  房间内固定位 = 3,
  房间内系统推荐弹窗 = 4,
  房间外系统推荐弹窗 = 5,
  其他 = 6,
  房间固定位半屏浮窗 = 7,
}

export enum DetailPageBuryingPointEnum {
  房间内固定位 = 0,
  推荐页点击 = 1,
  搜索结果点击 = 2,
  他人分享 = 3,
  房间内系统推荐弹窗 = 4,
  公会中心内主播自己查看 = 5,
  其他 = 6,
  房间固定位半屏浮窗 = 7,
  个人profile页 = 8,
  他人的profile页面 = 9,
  邀请弹窗 = 10,
  房间内个人资料页 = 11,
  邀请私信 = 12,
}

export enum JoinUnionStatusEnum {
  未加入 = 0,
  申请加入此公会中 = 1,
}

export enum SourceEnum {
  房间内申请 = 1,
  mid分享链接 = 2,
  系统推荐 = 3,
  主动加入 = 4,
}

export enum StatusEnum {
  未操作 = 0,
  已同意 = 1,
  过期失效 = 2,
  已拒绝 = 3,
  同意别的申请导致失效 = 4,
}

// 1公会长 2主播 3普通人 4管理员
export enum RoleStatus {
  Guild = 1,
  Anchor = 2,
  Live = 3,
  Manager = 4,
}

export enum CheckStatus {
  未填写 = 0, // 未填写---可以填写
  审核已通过 = 1, // 审核已通过---不能再填写
  审核已拒绝 = 2, // 审核已拒绝---可以填写
  未审核 = 3, // 未审核---可以填写
}
export const getMemberInfo = createAsyncThunk(
  'chatBD/hunting/getMemberInfo',
  async (p: {show_id: string}, store: any) => {
    const resp = await http.post(
      'live/account/get_member_info_by_show_id',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// 邀请主播
export const inviteUnionAnchor = createAsyncThunk(
  'UnionData/inviteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_add_from_leader',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 管理员邀请主播
export const inviteUser = createAsyncThunk(
  'UnionData/inviteUser',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_add_from_manager',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const handle_join_union_apply = createAsyncThunk(
  'JoinGuide/handle_join_union_apply',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/handle_join_union_apply',
      {
        ...p,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_leader_union_join_records = createAsyncThunk(
  'JoinGuide/get_leader_union_join_records',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_leader_union_join_records',
      {
        ...p,
        offset: 0,
        kind: 1,
        page_size: 10,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data?.list || []
  }
)

export const batch_get_union_role = createAsyncThunk(
  'JoinGuide/batch_get_union_role',
  async (params: any, store: any) => {
    const {h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/union/batch_get_union_role',
      {
        mids: [h_m],
      },
      {store, xcErrorToast: true}
    )
    const {role_map = {}} = resp.data.data
    return role_map[h_m]
  }
)
export const get_union_recommend_list = createAsyncThunk(
  'JoinGuide/get_union_recommend_list',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_union_recommend_list',
      {
        offset: 0,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const vip_level_info = createAsyncThunk(
  'JoinGuide/live/vip/level_info',
  async (p, store: any) => {
    const resp = await http.post('/live/vip/level_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data?.limit_level
  }
)
export const get_union_intro_info = createAsyncThunk(
  'JoinGuide/get_union_intro_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_union_intro_info', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
export const get_room_info_by_union_id = createAsyncThunk(
  'JoinGuide/get_room_info_by_union_id',
  async (p: any, store: any) => {
    const resp = await http.post('/live/room/get_room_info_by_union_id', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
export const anchor_confirm_invite = createAsyncThunk(
  'JoinGuide/anchor_confirm_invite',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_confirm_invite',
      {...p, is_from_h5: true},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const apply_join_union = createAsyncThunk(
  'JoinGuide/apply_join_union',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/apply_join_union', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  role?: RoleStatus
  limit_level?: number
  home: any
  detail: any
  record: any
  refund: any
  manage: any
}

const initialState: InitialStateType = {
  limit_level: 0,
  home: {},
  detail: {},
  record: {},
  refund: {},
  manage: {},
}

export const JoinGuideSlice = createSlice({
  name: 'JoinGuide',
  initialState,
  reducers: {
    updateHome: (state, action: PayloadAction<Array<any>>) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          list: action.payload,
        },
      })
    },
    updateManage: (state, action: PayloadAction<any>) => {
      Object.assign(state.manage, {
        ...action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_union_intro_info.fulfilled, (state, action) => {
      const {detail = {}} = state
      Object.assign(state, {
        detail: {
          ...detail,
          ...action.payload,
        },
      })
    })
    builder.addCase(get_room_info_by_union_id.fulfilled, (state, action) => {
      const {
        list = [],
        room_member_map = {},
        room_types = {},
      } = action.payload || {}
      const {detail = {}} = state
      Object.assign(state, {
        detail: {
          ...detail,
          list,
          room_member_map,
          room_types,
        },
      })
    })

    builder.addCase(get_union_recommend_list.fulfilled, (state, action) => {
      Object.assign(state, {
        home: {
          ...state.home,
          ...action.payload,
        },
      })
    })
    builder.addCase(batch_get_union_role.fulfilled, (state, action) => {
      Object.assign(state, {
        role: action.payload,
      })
    })
    builder.addCase(vip_level_info.fulfilled, (state, action) => {
      Object.assign(state, {
        limit_level: action.payload,
      })
    })
  },
})
export default JoinGuideSlice.reducer
export const JoinGuideActions = JoinGuideSlice.actions

export const useJoinGuideState = () => {
  const data = useSelector((state) => {
    return state.JoinGuide
  })
  return data
}
